<script lang="ts">
    export let iconId: string;
    export let rotate: boolean = false;
</script>

<div class="flex items-center justify-center transform transition-transform duration-300" class:rotate-180={rotate}>
    <i class="{iconId} transform"></i>
</div>
